const Form040TC = {
    stepName: {
        importantNotes: "重要事項",
        basicInformation: "基本資料",
        maximumCapacity: "最高容額",
        childrenServed: "服務兒童年歲",
        currentStaffStrength: "現時員工編制",
        existingFacilities: "現有設施",
        confirmation: "確認",
    },
    importantNotes: {
        p_importantNotes: "重要事項",
        p_importantNotes_one:
            "沒有「智方便+」值口的申請人須把已填妥的申請表交回幼稚園及幼兒中心聯合辦事處處理（地址：香港太古城太古灣道14號6樓602室）。請確保已為郵件支付足值郵資，以免未能送達本局。郵資不足的郵件，一律會由香港郵政處理。",
        p_title: "個人資料收集聲明",

        p_title_one: "<u>收集個人資料的目的</u>",
        p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        p1_a: "就申請調整幼稚園暨幼兒中心之幼兒中心（部份）容額事宜，包括聘用、培訓及職業前途發展、薪酬及福利、員工關係、通訊和程序遵行，辦理有關處理、核實及查證的事務；",
        p1_b: "就上文(a)項所述的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
        p1_c: "為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
        p1_d: "辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        p1_e: "辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
        p1_f: "辦理有關編製統計資料、研究材料及政府刊物的事務；以及",
        p1_g: "辦理有關施行及強制執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 (即《幼兒服務規例》(香港法例第243A章)的事務",
        p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",

        p_title_two: "<u>可獲轉移資料者</u>",
        p3: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        p3_a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
        p3_b: "受聘於教育局以提供服務或意見的人員、代理人、服務供應商或機構，以用於上文第1段所述的用途；",
        p3_c: "你曾就披露個人資料給予訂明同意；以及",
        p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        p_title_three: "<u>查閱個人資料</u>",
        p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 ",
    },
    notes: {
        pographySeven_url: "jokc@edb.gov.hk",
        termsConditions: "本人已閱讀、明白及同意上述條款及細則。",
        dot: "。",
    },

    // importantNotes: {
    //     p_title: "個人資料收集聲明 ",
    //     p1_1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
    //     p1_a: "進行核數工作；",
    //     p1_b: "進行研究及統計資料，以便規劃學前教育服務；",
    //     p1_c: "處理有關學前教育專業人員發展的事宜；",
    //     p1_d: "處理有關學前教育機構的營運事宜；",
    //     p1_e: "執行《教育條例》、《教育規例》、《幼兒服務條例》(第243章) 及《幼兒服務規例》(第243A章)。",

    //     p2: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
    //     p3: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
    //     p4: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
    //     p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    // },

    childrenAgeOption: {
        zeroThreeYears: "零至三歲",
        twoThreeYearsStepThree: "二至三歲",
        zeroSixYears: "零至六歲",
        twoSixYearsStepThree: "二至六歲",
    },
    workingHoursOption: {
        AmAndPm: "上午+下午",
        Am: "上午",
        Pm: "下午",
        Other: "其他工作時間",
    },
    FirstAidTrainingOption: {
        yes: "是",
        no: "否",
    },
    operatorTypeOption: {
        operator: "經營人",
        centreSupervisor: "中心主管",
        kindergartenPrincipal: "幼稚園校長",
    },
    positionTypeOption: {
        ccsInclusion: "幼兒工作主任編號",
        ccwInclusion: "幼兒工作員編號",
    },
    label: {
        applicantAddress: "申請人地址",
        nameOfKgCumCcc: "幼稚園暨幼兒中心名稱",
        addressOfKgCumCcc: "幼稚園暨幼兒中心地址",

        maximumCapacity: "（甲）（i）最高容額",
        existingApprovedCapacity: "（ii）現時批核容額",
        proposedCapacityAfterAdjustment: "（iii）建議調整容額",
        childrenServed: "（乙）服務兒童年歲（單選）",
        zeroTwoYears: "最高容額（零至二歲）",
        twoThreeYears: "最高容額（二至三歲）",
        twoSixYears: "最高容額（二至六歲）",

        currentStaffStrength: "（丙）現時員工編制",

        zeroThreeYears: "（i）零至三歲",
        twoThreeYearsStepThree: "（ii）二至三歲",
        zeroSixYears: "（iii）零至六歲",
        twoSixYearsStepThree: "（iv）二至六歲",

        proposedCapacityAfterAdjustmentWef: "建議調整容額生效日期",

        name: "姓名",
        hKid: "香港身份證號碼",
        passport: "護照號碼",
        hkidOrPassport: "香港身份證號碼／護照號碼",
        post: "職位",
        ccsInclusion: "幼兒工作主任編號",
        ccwInclusion: "幼兒工作員編號",
        ccsOrCCwInclusion: "幼兒工作主任編號／幼兒工作員編號",
        rtNo: "檢定教員註冊編號",
        ptNo: "有效准用教員編號",
        rtptNoType: "檢定教員註冊編號／有效准用教員編號",
        workingHours: "工作時間",
        otherWorkingHours: "請註明",
        firstAidCertNo: "有效急救證書編號",
        firstAidCertValidDate: "急救訓練證書生效日期",
        firstAidCertExpireDate: "急救訓練證書屆滿日期",
        firstAidTraining: "曾接受急救訓練",
        attachment: "附件（急救證書）",

        existingFacilities: "（丁）現有設施",

        toiletPans: "（i）兒童厠盆的數目",
        washBasins: "（ii）兒童洗手盆的數目",
        urinalTroughs: "（iii）尿槽／尿盆的數目",
        tips: "用“/”隔開這兩個數字",

        remarks:
            "本人明白需要僱用足夠的幼兒工作員／教學人員和提供充分的設備以符合幼兒服務規例、學前機構辦學手冊及敎育規例的要求。",
        Remarks: "（戊）注意事項",
        operatorType: "經營人／中心主管／幼稚園校長",
        operatorName: "{{type}}姓名",
        telNo: "電話號碼",
        statement:
            "本人現申請調整上述幼稚園暨幼兒中心之幼兒中心（部份）容額，詳情如下：",
    },
    tooltip: {
        tipOne: "尿槽長度不可少於450毫米",
    },
    table: {
        ageRange: "年齡範圍",
        fullDay: "全日",
        am: "上午",
        pm: "下午",
        existingZeroTwoYears: "零至二歲",
        existingTwoThreeYears: "二至三歲",
        existingTwoSixYears: "二至六歲",
        proposedZeroTwoYears: "零至二歲",
        proposedTwoThreeYears: "二至三歲",
        proposedTwoSixYears: "二至六歲",
        tooltip0To999: "0-999",
    },
    errorMsg: {
        specify: "註明",
        E0015: "兒童厠盆的數目必填",
        E0016: "兒童洗手盆的數目必填",
        E0017: "尿槽/尿盆的數目必填",
        E0018: "請勾選",

        E0026: "（i）, （ii） 和 （iii）總數必須大於0",
        E0027: "最大長度不能超過1000",
        E0028: "最大長度不能超過200",
        E0029: "最高容額總數必須大於0",
        existingTotal: "現時批核容額總數必須大於0",
        proposedTotal: "建議調整容額總數必須大於0",
        E0031: "格式不正確",
        E0032: "香港身份證號碼和護照號碼必須填其中一個",
        E0033: "幼兒工作主任編號和幼兒工作員編號必須填其中一個",
        E0034: "每項最小值為0，最大值為99",
        atLeastOne: "必須至少有一位員工曾接受急救訓練",
        atLeast: "請至少填寫一個編號",
        existingMsg:
            "於各年齡範圍填寫的（ii）現時批核容額不可大於該年齡範圍的（i）最高容額。",
        proposedMsg:
            "於各年齡範圍填寫的（iii）建議調整容額不可大於該年齡範圍的（i）最高容額。",
        afterToday: "急救證書屆滿日期必須在今天之後",
        isExistingMsgEmpty: "如最高容額為空, 同年齡範圍的現批容額都要為空",
        isProposedMsgEmpty: "如最高容額為空, 同年齡範圍的建議調整容額都要為空",
    },
    submittedDialog: {
        text1: "你已成功送出表格。請注意表格尚未提交至教育局。表格正在等待學校審批。",
        text2: "你已成功送出表格。請注意表格尚未提交至教育局。表格正在等待教育局審核。",
    },
};
export default Form040TC;
